import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import appRouter from './routes/appRouter';
import AuthRouter from './routes/AuthRouter';


document.title = process.env.REACT_APP_PAGE_TITLE;

const observerError = "ResizeObserver loop completed with undelivered notifications.";
window.addEventListener("error", (e) => {
  if (e.message === observerError) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthRouter>
      <RouterProvider router={appRouter} />
    </AuthRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
